
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customlistadeinmueblesdestacadosr55jz_67c86707a9c8dc86c6729527 } from '../../api/inmuebles5x55o.api'

import './pginadeinicio28aeyk.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Ppginadeinicio28aeyk = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyres_67c86707a9c8dc86c6729527_component_itd9vz, setloftyres_67c86707a9c8dc86c6729527_component_itd9vz] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadeinmueblesdestacadosr55jz_67c86707a9c8dc86c6729527({
				});
				setloftyres_67c86707a9c8dc86c6729527_component_itd9vz(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id676ecd36df08e4838cb85e52" >

      <div id="iw4j" className="">
      
      <div id="i7iuy6" className="">
      
      <div id="ikooaf" className="">
      
      <span className="material-icons " id="iv5d9d">
        
      <span className="material-icons " id="iqcwn3">
        <>call</>
      </span>
      
      </span>
      
      <div className="" id="iwehdy">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijj06m">
        <>(+504) 9452-3409 </>
      </span>
      
      </div>
      
      <div className="" id="iws54s">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9drhg">
        <>(+504) 3292-8788</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ips2" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56xoug0.png"
        alt="undefined"
      />
      
      <div id="ifvvzp" className="">
      
      <a
        target=""
        className=""
        id="inedox"
        href="/"
        type="button"
      >
        
    <div id="iclrrs" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iacjt4"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ivmnu1" className="">
    <>Sobre Nosotros</>
    </div>
    
      </a>
      
        <LoftyDropdownComponent
          id="i31a31"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="i3bwm8" className="gjs-dropdown-menu-trigger ">
<>Inmuebles</></div>

            </>
          }
          childrenHover={
            <>
              <div id="i682c3" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className="link-navbar "
          id="isflkh"
          href={`/inmueblesenrenta`}
        >
          
    <div id="ih5gzi" className="">
    <>En Renta</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navbar "
          id="icxmdj"
          href={`/inmueblesenventa`}
        >
          
    <div id="ijv4mh" className="">
    <>En Venta</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
      <a
        target=""
        className=""
        id="ih0w28"
        href="/contacto"
        type="button"
      >
        
    <div id="i89xkj" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/inmueblesenrenta"
        type=""
      >
        <>Inmuebles en Renta</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/inmueblesenventa"
        type=""
      >
        <>Inmuebles en Venta</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div id="if5pi" className="">
      
      <img
        className=""
        id="iz9d4"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56xukok.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ikb1zf">
        <>La mejor opción para venta/compra/renta de un inmueble</>
      </span>
      
      </div>
      
      <div className="" id="i803s">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i188nr">
        <>Desde 2019 siendo la mejor opción para venta/compra/renta de un inmueble, te ayudamos y asesoramos para tomar la mejor decisión. </>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i6xx" className="">
      
      <div className="" id="igqyi">
        <>Destacados de la semana</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="itt6pr">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i8gkam">
        <>Más de 10.000 clientes satisfechos con nosotros. ¿Eres el próximo?</>
      </span>
      
      </div>
      
        <div id="itd9vz" className="">
        
            {
              loftyres_67c86707a9c8dc86c6729527_component_itd9vz.map((loftyitem_67c86707a9c8dc86c6729527_component_itd9vz) => (
                <div key={loftyitem_67c86707a9c8dc86c6729527_component_itd9vz._id} className="" id="i8bpws">
                  
      <div
        id="igj5hj"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
        <img
          className=""
          id="irfzvt"
          alt=""
          src={loftyitem_67c86707a9c8dc86c6729527_component_itd9vz.loftyUrl}
        />
        
      <div id="itavrc" className="">
      
        <div className="" id="izam5l">
          
          <div className="" id="">
            {loftyitem_67c86707a9c8dc86c6729527_component_itd9vz?.titulop4an9}
          </div>
          
        </div>
        
      </div>
      
      <div id="insp1x" className="">
      
        <a
          target=""
          className=""
          id="iqrbzj"
          href={`/visualizacioninmueble/${loftyitem_67c86707a9c8dc86c6729527_component_itd9vz._id}`}
        >
          
      <span className="" id="ipn6b3">
        <>Visualizar detalles</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
                </div>
              ))
            }
            
        </div>
        
        <a
          target=""
          className=""
          id="ijv0kn"
          href={`/inmueblesenventa`}
        >
          
      <span className="" id="i0jizn">
        <>Ver Todas</>
      </span>
      
        </a>
        
      </div>
      
      <div id="i3dh" className="">
      
      <div className="" id="ijh55q">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9aoc8">
        <>¿Qué podemos hacer por ti?</>
      </span>
      
      </div>
      
      <div id="ihp5j" className="">
      
      <div id="idydx" className="">
      
      <div id="i6tai" className="">
      
      <div id="ii0avl" className="">
      
      <img
        className=""
        id="ilqcl"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56yhfhm.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ittgrj" className="">
      
      <div className="" id="ivfd5">
        <>Compra</>
      </div>
      
      <div className="" id="iyi33">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ix7636">
        <>Explora nuestra amplia selección de propiedades en venta. Desde casas modernas hasta departamentos exclusivos, tenemos lo que necesitas</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i6zh56" className="">
      
      <div id="il48mp" className="">
      
      <img
        className=""
        id="iuraih"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56yhh1b.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="idhne6" className="">
      
      <div className="" id="i94m8f">
        <>Venta</>
      </div>
      
      <div className="" id="imxr2f">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iuir4x">
        <>Vende tu propiedad de manera rápida y efectiva con nuestro equipo de expertos.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ien4cg" className="">
      
      <div id="iph1y3" className="">
      
      <img
        className=""
        id="i17tl3"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56yhigu.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ien2jj" className="">
      
      <div className="" id="iktcml">
        <>Renta</>
      </div>
      
      <div className="" id="i8iwcl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ihkqaz">
        <>Encuentra el lugar perfecto para vivir o trabajar con opciones adaptadas a tus necesidades.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i7qj2" className="">
      
      <div id="ill6r1" className="">
      
      </div>
      
      <div id="ipaium" className="">
      
      <div className="" id="iku0hm">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ixhtq8">
        <>Haz realidad tus sueños hoy</>
      </span>
      
      </div>
      
      <div className="" id="it973s">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ieshca">
        <>No esperes más para encontrar el hogar perfecto o la inversión ideal. Contáctanos y descubre por qué somos la mejor opción en bienes raíces. Nuestro equipo de profesionales está listo para atenderte.</>
      </span>
      
      </div>
      
        <a
          target=""
          className=""
          id="i6g2ow"
          href="#"
        >
          
      <span className="" id="">
        <>Contáctanos</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
      <div id="i99qgf" className="">
      
      <div id="i4lkco" className="">
      
      <div className="" id="ie80ow">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9q38f">
        <>Lo que hemos logrado</>
      </span>
      
      </div>
      
      <div className="" id="i9f744">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="it92lk">
        <>Somos miembros activos de Asociación Nacional de Inmobiliarias del País ( ANAIP )</>
      </span>
      
      </div>
      
        <a
          target=""
          className=""
          id="ixro22"
          href="#"
        >
          
      <span className="" id="itbe6o">
        <>Contáctanos</>
      </span>
      
        </a>
        
      </div>
      
      <div id="i64unl" className="">
      
      </div>
      
      </div>
      
      <div id="il4d9o" className="">
      
      <div id="ioigc7" className="">
      
      <div id="ir2su1" className="">
      
      <img
        className=""
        id="imr6xn"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56z3fz2.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iip0hj" className="">
      
      <div id="icdzzf" className="">
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <>Sobre Nosotros</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ig1at"
        href="/contacto"
        type="button"
      >
        
    <div id="isq53" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      <div id="inxorr" className="">
      
      <img
        className=""
        id="iib493"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56z589z.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i9jwhn">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ilrddl">
        <>Teléfono: +504 33445633 
Correo electrónico: informacion@grupodor.com 
Dirección: Colonia Universidad, 24 calle, 9 avenida, Plaza Bulevares, San Pedro Sula, Cortés, Honduras C.A.</>
      </span>
      
      </div>
      
      <div id="ikrieu" className="">
      
        <a
          target="_blank"
          className=""
          id="iugvxb"
          href="https://www.facebook.com/DORInmobiliariaHN/?_rdr"
        >
          
      <span className="" id="ifk2kr">
        <>Facebook</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="iewo54"
          href="https://www.instagram.com/dorinmobiliaria"
        >
          
      <span className="" id="ig11q1">
        <>Instagram</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ixgr5i"
          href="https://www.linkedin.com/company/dor-inmobiliaria/"
        >
          
      <span className="" id="iz2xzh">
        <>LinkedIn</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="imier2" className="">
      
      <div id="i50ldy" className="">
      
      </div>
      
      <div id="igphyo" className="">
      
      <div className="" id="i1gmf4">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iy1e52">
        <>DOR © 2024. Todos los derechos reservados</>
      </span>
      
      </div>
      
      <div className="" id="ids74n">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="izx0i8">
        <>Términos de uso</>
      </span>
      
      </div>
      
      <div className="" id="i6pgi9">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itfy23">
        <>Políticas de privaciad</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Ppginadeinicio28aeyk);
  